import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getMonthRangeDatesMTD } from 'utils/date-functions';

import CancelledMembersPageHeader from './components/CancelledMembersPageHeader';
import CancelledMembersTable from './components/CancelledMembersTable';
import { SearchFilters } from './types';

const CancelledMembers = (): JSX.Element => {
  const defaultDates = getMonthRangeDatesMTD();

  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [defaultDates[0], defaultDates[1]],
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('cancelationDate');

  return (
    <>
      <CancelledMembersPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
      />

      <CancelledMembersTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default CancelledMembers;
